import { Component, Inject, inject, OnDestroy } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBar,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SnackService } from '@app/components/shared/snack/snack.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'faxe-snack-bar',
  template: '',
  styles: [], // Or remove this line if no styles are used
  imports: [MatFormFieldModule, FormsModule, MatInputModule, MatButtonModule],
})
export class SnackComponent implements OnDestroy {
  private _snackBar = inject(MatSnackBar);
  private _snackService = inject(SnackService);
  private unsubscribe$ = new Subject<void>();
  durationInSeconds = 5;

  constructor() {
    this._snackService.snackMessages$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((signal) => {
        if (signal) {
          this._snackBar.openFromComponent(FaxeAnnotatedComponent, {
            data: signal,
            duration: this.durationInSeconds * 1000,
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

@Component({
  selector: 'faxe-snack-bar-annotated-component',
  template: `
    <div style="display: flex; justify-content: space-between; align-items: center;">
     <span style="color: var(--palette-A700); font-size: 1.25rem;">
        {{ data }}
      </span>
      <span>
        <button mat-button (click)="snackBarRef.dismissWithAction()" style="margin-left: auto;">
          <img src="assets/icons/faxeit.ico" alt="Faxeit Icon" style="width: 48px; height: 48px; margin-right: 8px;" />
        </button>
      </span>
    </div>
  `,
  imports: [MatButtonModule],
})
export class FaxeAnnotatedComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {}
}
